import React from 'react'

import './Policies.css'

const Policies = () => {
    return (
        <div>
            <h1>This is the policies page</h1>
        </div>
    )
}

export default Policies